import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components/AlertBadge';
import { getSurveyCampaignByIdResponsesResultsStatsCall } from '../../state';
import { DistributionBox } from './DistributionBox';
import { OverallBox } from './OverallBox';
import { ResultsByDepartments } from './ResultsByDepartments';

export const TabDepartmentsResultsSurvey = () => {
  const tShared = useTranslations();
  const { campaignId } = useParams();

  const {
    execute: executeGetSurveyCampaignByIdResponsesResultsStats,
    loading: loadingGetSurveyCampaignByIdResponsesResultsStats,
    error: errorGetSurveyCampaignByIdResponsesResultsStats,
    success: successGetSurveyCampaignByIdResponsesResultsStats,
  } = getSurveyCampaignByIdResponsesResultsStatsCall.hook();

  useEffect(() => {
    if (campaignId) {
      executeGetSurveyCampaignByIdResponsesResultsStats({
        campaignId,
      });
    }
  }, [campaignId, executeGetSurveyCampaignByIdResponsesResultsStats]);

  if (loadingGetSurveyCampaignByIdResponsesResultsStats) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorGetSurveyCampaignByIdResponsesResultsStats) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge containerProps={{ mt: 's' }} iconName='info' type='error' label={message} />;
  }

  if (
    !loadingGetSurveyCampaignByIdResponsesResultsStats &&
    !errorGetSurveyCampaignByIdResponsesResultsStats &&
    successGetSurveyCampaignByIdResponsesResultsStats
  ) {
    return (
      <Box mt='m'>
        <DistributionBox />
        <OverallBox />
        <ResultsByDepartments />
      </Box>
    );
  }

  return null;
};
